/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { history } from 'Store';
import { DashboardProgressActive } from '@carvana/purchase-icons';
import * as sc from './navigation-tab.styles';

const NavTab = ({ isActive, navItem }) => {
  const { showSummary } = useSelector(state => state.ui);
  const { isComplete, isDisabled, route } = navItem;
  const timeEst = navItem?.completionTimeEstimate;

  return (
    <sc.NavTab
      className={[isDisabled && 'disabled', isActive && !showSummary && 'active']}
      onClick={() => !isDisabled && (!isActive || showSummary) && history.push(route)}
    >
      <sc.NavTabIconWrapper>
        {navItem.inProgress ? <DashboardProgressActive />
          : isComplete ? <sc.CompleteIconGreen />
          : <sc.IncompleteIcon />
        }
      </sc.NavTabIconWrapper>
      <sc.NavTabTextWrapper>
        <sc.NavTabText>{navItem.title}</sc.NavTabText>
        {timeEst &&
          <sc.NavTabSubtext>
            {isComplete ? 'Complete'
              : `About ${timeEst} minute${timeEst > 1 ? 's' : ''}`
            }
          </sc.NavTabSubtext>
        }
      </sc.NavTabTextWrapper>
      {(!isDisabled || showSummary) && <sc.NavTabArrow />}
    </sc.NavTab>
  );
};

NavTab.propTypes = {
  isActive: PropTypes.bool.isRequired,
  navItem: PropTypes.shape({}).isRequired
};

export default NavTab;
